import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lns-login-layout',
  templateUrl: './login-layout.component.html'
})
export class LoginLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
